import styles from "./index.module.scss";

import virgin from "../../../assets/illustrations/map/virgin.svg"
import fr from "../../../assets/illustrations/map/fr.svg"
import ca from "../../../assets/illustrations/map/ca.svg"
import ca_fr from "../../../assets/illustrations/map/ca-fr.svg"
import all from "../../../assets/illustrations/map/all.svg"
import { LOCATIONS, useLocation } from "../../../hooks/useLocation";


export const Map = () => {
    const { location } = useLocation();

    let image;
    switch (location) {
        case LOCATIONS.FRANCE:
            image = fr;
            break;
        case LOCATIONS.CANADA:
            image = ca;
            break;
        case LOCATIONS.CANADA_AND_FRANCE:
            image = ca_fr;
            break;
        case LOCATIONS.WORLDWIDE:
            image = all;
            break;
        default:
            image = virgin;
    }

    return (
        <div className={styles.map}>
            <img src={image} alt="Map" className={styles.mapImage} />
        </div>
    );
}